module.exports = __webpack_public_path__ + "static/media/good-luck.5883ceca.mp3";